module.exports = __webpack_public_path__ + "static/media/swscrc2-2.4f2e82f6.mp3";